var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripe-component"},[_c('div',{staticClass:"field credit_card_wrapper"},[_c('div',{staticClass:"cc_number_card flat flex items-center h-full pt-05 mb-4"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }